var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E4C1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2626 16.625C17.9203 18.8006 15.9432 20.8118 13.9709 20.8118C13.9629 20.8118 13.9548 20.8118 13.9468 20.8118C13.9388 20.8118 13.9307 20.8118 13.9227 20.8118C11.9504 20.8118 9.97335 18.8006 9.63098 16.625",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2627 16.6231C18.851 16.4056 19.2753 15.7626 19.2753 15.0084C19.2753 14.2542 18.851 13.6112 18.2627 13.3984",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63045 16.6231C9.04215 16.4056 8.6178 15.7626 8.6178 15.0084C8.6178 14.2542 9.04215 13.6112 9.63045 13.3984",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5243 9.21094C12.28 10.957 11.1395 12.4977 9.63098 13.4025",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5242 9.21094C14.0174 11.2117 16.0861 12.7047 18.4522 13.4904",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3815 13.8516C15.9821 13.8516 15.6582 14.198 15.6582 14.6251C15.6582 15.0522 15.9821 15.3986 16.3815 15.3986C16.781 15.3986 17.1049 15.0522 17.1049 14.6251C17.1049 14.198 16.965 13.8516 16.3815 13.8516Z",
    fill: "#344266"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5599 13.8516C11.9593 13.8516 12.2832 14.198 12.2832 14.6251C12.2832 15.0522 11.9593 15.3986 11.5599 15.3986C11.1604 15.3986 10.8365 15.0522 10.8365 14.6251C10.8365 14.198 10.9764 13.8516 11.5599 13.8516Z",
    fill: "#344266"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4518 17.6702C13.3198 18.6162 14.6306 18.6073 15.4897 17.6484",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0665 6.31159C13.0665 6.31159 13.7199 5.82812 15.4881 5.82812C17.2562 5.82812 21.6861 8.77804 21.6861 13.5635C21.6861 16.8575 21.2039 16.4038 21.2039 19.365C21.2039 20.1901 21.4699 20.7203 22.1684 21.7823C22.1684 21.7823 19.6367 23.0877 17.8284 20.8154",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0665 6.3119C10.9086 5.49646 6.31547 8.77835 6.31547 13.5638C6.31547 16.8578 6.79768 16.4041 6.79768 19.3653C6.79768 20.1904 6.53166 20.7206 5.83325 21.7826C5.83325 21.7826 8.42516 23.1073 10.1732 20.8157",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/FemaleIcon.d0ab3be782962d790e2b288c2b44b82e.svg";
export { ForwardRef as ReactComponent };